import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as Msal from 'msal';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import { BrowserCacheLocation } from '@azure/msal-browser';


export const MSAL_CONFIG_CASP : Msal.Configuration = {
    auth: {
      clientId: environment.uiClienId,
      authority: 'https://login.microsoftonline.com/' + environment.tenantId,
      redirectUri: environment.redirectUrl,
      postLogoutRedirectUri: environment.redirectUrlLogOut
    },
    cache: {
      storeAuthStateInCookie: false,
      cacheLocation: BrowserCacheLocation.SessionStorage
      // cacheLocation: 'localStorage' ,
    }
  }



@Injectable({
  providedIn: 'root'
})
export class MsalService {

private accessToken: any;
public clientApplication: Msal.UserAgentApplication = null;

constructor(private userService: UserService) {

  this.clientApplication = new Msal.UserAgentApplication(MSAL_CONFIG_CASP);
}



  public GetAccessToken(): Observable<any> {
    if (sessionStorage.getItem('msal.idtoken') !== undefined && sessionStorage.getItem('msal.idtoken') != null) {
      this.accessToken = sessionStorage.getItem('msal.idtoken');
    }
    return this.accessToken;
  }

  public authCallback(token: string) {
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  public getCurrentUserInfo() {
    const user = this.clientApplication.getAccount();
    // console.log(user);
  }

  public async logout() {
    try {
      await this.userService.closeSession();
    } catch (error) {
      console.error('error', error);
    } finally {
      localStorage.clear();
      this.clientApplication.logout();
    }
  }
}
